module.exports = __webpack_public_path__ + "img/file.94eded8f.svg";